// this file with actual API results or remove it entirely.

export const DUMMY_CANDIDATES = [
  {
    id: "cand-1",
    fullName: "Adebayo Johnson",
    position: "Presidential Candidate",
    state: "Lagos",
    party: "People's Unity Party (PUP)",
    organizationID: "ORG-001",
    avatar: null,
    createdAt: "2025-01-10T09:00:00.000Z",
    updatedAt: "2025-02-05T12:30:00.000Z",
  },
  {
    id: "cand-2",
    fullName: "Chioma Okafor",
    position: "Gubernatorial Candidate",
    state: "Anambra",
    party: "Progressive Alliance Party (PAP)",
    organizationID: "ORG-002",
    avatar: null,
    createdAt: "2025-01-15T11:15:00.000Z",
    updatedAt: "2025-02-06T14:45:00.000Z",
  },
  {
    id: "cand-3",
    fullName: "Ibrahim Musa",
    position: "Senatorial Candidate",
    state: "Kano",
    party: "National Reform Congress (NRC)",
    organizationID: "ORG-003",
    avatar: null,
    createdAt: "2025-01-20T08:20:00.000Z",
    updatedAt: "2025-02-07T10:10:00.000Z",
  },
  {
    id: "cand-4",
    fullName: "Zainab Bello",
    position: "National Assembly Candidate",
    state: "Kaduna",
    party: "United Peoples Movement (UPM)",
    organizationID: "ORG-004",
    avatar: null,
    createdAt: "2025-01-22T13:40:00.000Z",
    updatedAt: "2025-02-08T16:05:00.000Z",
  },
  {
    id: "cand-5",
    fullName: "Tunde Akinwale",
    position: "Chairmanship Candidate",
    state: "Oyo",
    party: "Grassroots Development Party (GDP)",
    organizationID: "ORG-005",
    avatar: null,
    createdAt: "2025-01-25T07:50:00.000Z",
    updatedAt: "2025-02-09T09:25:00.000Z",
  },
  {
    id: "cand-6",
    fullName: "Hadiza Garba",
    position: "Councillorship Candidate",
    state: "Abuja (FCT)",
    party: "New Vision Party (NVP)",
    organizationID: "ORG-006",
    avatar: null,
    createdAt: "2025-01-28T10:05:00.000Z",
    updatedAt: "2025-02-10T11:55:00.000Z",
  },
];
